<template><section class="cta"><div><p class="eyebrow">{{ $t('cta.eyebrow') }}</p><h2>{{ $t('cta.title') }}</h2><p>{{ $t('cta.text') }}</p></div><router-link class="button" to="/contact">{{ $t('cta.button') }} <span>↗</span></router-link></section></template>
<script>export default { name: 'ContactCta' }</script>
